// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-guide[data-v-45b36ca7] {\n  height: calc(100% - 16px);\n  margin: 8px;\n}\n.embeded-pdf-viewer[data-v-45b36ca7] {\n  height: 100%;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
